import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('WamDialogs');

export const ONBOARD_DIALOG_SHOW = ActionType.simple('ONBOARD_DIALOG_SHOW');
export const ONBOARD_DIALOG_HIDE = ActionType.simple('ONBOARD_DIALOG_HIDE');

export const WAMSOON_SHOW = ActionType.simple('WAMSOON_SHOW');
export const WAMSOON_HIDE = ActionType.simple('WAMSOON_HIDE');

export const WAMNOW_SHOW = ActionType.simple('WAMNOW_SHOW');
export const WAMNOW_HIDE = ActionType.simple('WAMNOW_HIDE');

export const CHATSOON_SHOW = ActionType.simple('CHATSOON_SHOW');
export const CHATSOON_HIDE = ActionType.simple('CHATSOON_HIDE');

export const CHATNOW_SHOW = ActionType.simple('CHATNOW_SHOW');
export const CHATNOW_HIDE = ActionType.simple('CHATNOW_HIDE');
